<template>
  <div>
    <div v-if="loader">
      <v-skeleton-loader
        v-for="i in 1"
        :key="i"
        transition-group="fade-transition"
        type="table-tfoot, list-item-two-line, image"
      ></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="substances"
          :items-per-page="5"
          class="elevation-4"
          item-key="id"
          show-select
          checkbox-color="primary"
          :footer-props="{
            'items-per-page-text': `${$t('generic.LinePerPage')}`,
            'items-per-page-all-text': `${$t('generic.All')}`,
          }"
          :no-data-text="`${$t('generic.noFav')}`"
        >
          <template v-slot:top>
            <v-toolbar flat :height="toolbar_height">
              <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                {{ $t("fav.yourSubFav") }}
              </v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
                v-if="$vuetify.breakpoint.mdAndUp"
              ></v-divider>
              <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
              <v-row justify="space-around">
                <!-- BTN IMPORT -->
                <v-btn
                  class="my-1"
                  depressed
                  color="secondary"
                  @click="prepaImport()"
                >
                  {{ $t("generic.Import") }} {{ $t("generic.myFav") }}
                </v-btn>

                <!-- BTN EXPORT -->
                <vue-excel-xlsx
                  :data="substances"
                  :columns="columns"
                  :file-name="$t('fav.fileName')"
                  :file-type="'xlsx'"
                  :sheet-name="'Substances'"
                >
                  <v-btn
                    class="my-1"
                    depressed
                    color="secondary"
                    @click="monitoreExport()"
                    :disabled="substances.length === 0"
                  >
                    {{ $t("generic.Export") }} {{ $t("generic.myFav") }}
                  </v-btn>
                </vue-excel-xlsx>

                <!-- BTN SUPPRIMER -->
                <div v-if="selected.length > 0">
                  <v-btn
                    @click="deleteMultiItem(selected)"
                    depressed
                    color="primary"
                    class="my-1"
                  >
                    {{ $t("generic.Delete") }}
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn depressed disabled color="primary" class="my-1">
                    {{ $t("generic.Delete") }}
                  </v-btn>
                </div>
              </v-row>
            </v-toolbar>
            <v-divider class="mx-4"></v-divider>

            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title
                  class="text-h5 text-center"
                  style="word-break: normal"
                >
                  {{ $t("fav.deleteOneSub") }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="closeDelete" small>
                    {{ $t("generic.cancel") }}
                  </v-btn>
                  <v-btn color="primary" @click="deleteItemConfirm">{{
                    $t("generic.Yes")
                  }}</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>

          <template v-slot:[`item.usual_name`]="{ item }">
            <v-card flat color="transparent" @click="goToSub(item.id)">
              <p class="my-auto py-2">
                {{ item.usual_name }}
              </p>
            </v-card>
          </template>
          <template v-slot:[`item.ce`]="{ item }">
            <p class="my-auto py-2" style="width: 100px">{{ item.ce }}</p>
          </template>
          <template v-slot:[`item.cas`]="{ item }">
            <p class="my-auto py-2" style="width: 100px">{{ item.cas }}</p>
          </template>
          <template v-slot:[`item.supprimer`]="{ item }">
            <v-icon small icon @click="deleteItem(item)" color="primary">
              mdi-delete
            </v-icon>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            {{ items.pageStart }} - {{ items.pageStop }} {{ $t("generic.of") }}
            {{ items.itemsLength }}
          </template>
        </v-data-table>

        <v-dialog v-model="dialogMultiDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5 text-center">
              {{ $t("fav.deleteManySub") }} ({{ selected.length }})
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="closeMultiDelete">{{
                $t("generic.cancel")
              }}</v-btn>
              <v-btn color="primary" @click="deleteMultiItemConfirm(selected)">
                {{ $t("generic.Yes") }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- Pop Up D'import -->
        <v-dialog v-model="dialogImport" max-width="800px">
          <import-sub
            v-on:closeImport="closeImport"
            v-on:updateFav="updateFav"
            type="fav"
          ></import-sub>
        </v-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ImportSub from "./ImportSub.vue";
import { monitore } from "./helpers/helpers";

export default {
  data: () => ({
    selected: [],
    dialogDelete: false,
    dialogMultiDelete: false,
    dialogImport: false,
    editedIndex: -1,
    editedItem: {
      usual_name: "",
      ce: "",
      cas: "",
    },
    defaultItem: {
      usual_name: "",
      ce: "",
      cas: "",
    },
    columns: [
      {
        label: "Name",
        field: "usual_name",
      },
      {
        label: "N°CE",
        field: "ce",
      },
      {
        label: "N°CAS",
        field: "cas",
      },
    ],
    loader: false,
  }),
  props: {
    substances: Array,
  },
  components: {
    ImportSub,
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("generic.UsualName"),
          align: "start",
          sortable: false,
          value: "usual_name",
        },
        { text: "N° CE", value: "ce" },
        { text: "N° CAS", value: "cas" },
        {
          text: this.$t("generic.Delete"),
          value: "supprimer",
          sortable: false,
          align: "center",
        },
      ];
    },
    ...mapGetters(["subs_fav", "identity"]),
    subFavList() {
      let subFavList = [];
      if (this.substances.length) {
        this.substances.forEach((substance) => {
          subFavList.push(substance.id);
        });
      }
      return subFavList;
    },
    noFav: function () {
      if (this.subFavList.length === 0) {
        return true;
      } else {
        return false;
      }
    },
    toolbar_height() {
      let height = "";
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          height = "150px";
          break;
        case "sm":
          height = "";
          break;
        case "md":
          height = "";
          break;
        case "lg":
          height = "";
          break;
        case "xl":
          height = "";
          break;
      }
      return height;
    },
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogMultiDelete(val) {
      val || this.closeMultiDelete();
    },
    dialogImport(val) {
      val || this.closeImport();
    },
  },
  beforeMount() {
    var that = this;
    // console.log(that.substances);
    if (!that.substances.length) {
      that.loader = true;
    }
    setTimeout(() => {
      this.loader = false;
    }, 1000);
  },
  methods: {
    ...mapMutations(["setFavoritesSubstances", "setLastPage"]),
    ...mapActions(["updateProfile"]),

    // Dialog activator
    deleteItem(item) {
      this.editedIndex = this.substances.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteMultiItem(items) {
      if (items.length == 1) {
        let single_item = items[0];
        this.deleteItem(single_item);
        this.selected = [];
      } else {
        this.dialogMultiDelete = true;
      }
    },

    // delete l'item de l'array substances
    async deleteItemConfirm() {
      this.substances.splice(this.editedIndex, 1);
      this.closeDelete();
      // console.log(this.subFavList);
      this.setFavoritesSubstances(this.subFavList);
      await this.updateProfile();
    },

    // delete les items de l'array substances
    async deleteMultiItemConfirm(items) {
      let index = 0;
      items.forEach((item) => {
        index = this.substances.indexOf(item);
        this.substances.splice(index, 1);
      });
      this.selected = [];
      // console.log(this.subFavList);
      this.setFavoritesSubstances(this.subFavList);
      await this.updateProfile();
      this.closeMultiDelete();
    },

    // close dialog actions
    closeMultiDelete() {
      this.dialogMultiDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    // ------------------
    // FONCTIONS D'IMPORT
    // ------------------
    prepaImport() {
      this.dialogImport = true;
    },
    closeImport() {
      this.dialogImport = false;
    },
    updateFav() {
      this.$emit("updateFav");
      this.dialogImport = false;
      this.$nextTick(() => {});
    },
    goToSub(sub, rule) {
      this.setLastPage({ name: "Favorites", params: { tab: 1 } });
      this.$router.push({
        name: "ShowSubstances",
        params: { id: sub, rule: rule },
      });
    },
    monitoreExport() {
      monitore("Export substances fav");
    },
  },
};
</script>